module.exports = __webpack_public_path__ + "bbf3d4349315e7627d03316619c53ae5.svg";